export const LEGAL_COMPLIANCE_COUNTRY_CODES: readonly string[] = ['US', 'GB']
export const LEGAL_PAYWALL_COUNTRY_CODES: readonly string[] = ['US']

export const TERMS_OF_SERVICE_URL = 'https://quiz.mygrowth.one/terms-of-use#'
export const PRIVACY_POLICY_URL = 'https://quiz.mygrowth.one/privacy-policy#'
